import object from '@mailobj-browser/front/js/utils/object.js'

export default (
  target
) => {
  const rect = target.getBoundingClientRect()
  const { bottom, height, left, right, top, width, x, y } = rect
  
  return object(null, { bottom, height, left, right, top, width, x, y })
}
